import { CompleteYourPaymentScreen } from '@/modules/payments/CompleteYourPaymentScreen';

export default function PaymentMethodSelectRoute() {
    return <CompleteYourPaymentScreen />;
}
